import React, { useState } from "react";
import "../InsightMenu/InsightPreview.scss";
import Respondent from "../../../assets/images/respondent.png";

const DUMMY_DATA = [
    {
        name: "Team_237",
        mobile: "--",
        email: "Team_237@test.com",
        date: "30-Oct-2025 05:30:00"
    },
    {
        name: "Team_174",
        mobile: "--",
        email: "Team_174@test.com",
        date: "12-Feb-2025 05:30:00"
    },
    {
        name: "Team_200",
        mobile: "--",
        email: "Team_200@test.com",
        date: "03-Jan-2026 05:30:00"
    },
    {
        name: "Team_227",
        mobile: "--",
        email: "Team_227@test.com",
        date: "30-Oct-2025 05:30:00"
    }
];

const RespondentPreview = () => {
    const [activeTab, setActiveTab] = useState("respondent");

    return (
        <div className="respondent-preview">
            <img alt="" src={Respondent} className="preview-img w-100" />
            {/* 🔹 Tabs */}
            {/* <div className="preview-tabs">
                <button
                    className={activeTab === "respondent" ? "active" : ""}
                    onClick={() => setActiveTab("respondent")}
                >
                    Respondent
                </button>
                <button
                    className={activeTab === "non-respondent" ? "active" : ""}
                    onClick={() => setActiveTab("non-respondent")}
                >
                    Non-Respondent
                </button>
            </div> */}

            {/* 🔹 Controls */}
            {/* <div className="preview-controls">
                <div className="left">
                    <button className="primary-btn">Filter</button>
                    <button className="primary-btn">Show Columns</button>
                </div>

                <div className="right">
                    <input type="text" placeholder="Search" />
                    <button className="icon-btn">⬇</button>
                </div>
            </div> */}

            {/* 🔹 Table */}
            {/* <div className="preview-table">
                <div className="table-header">
                    <div><input type="checkbox" /></div>
                    <div>Respondent</div>
                    <div>Mobile No</div>
                    <div>Email</div>
                    <div>Date</div>
                    <div>View</div>
                    <div>Action</div>
                </div>

                {DUMMY_DATA.map((row, idx) => (
                    <div className="table-row" key={idx}>
                        <div><input type="checkbox" /></div>
                        <div className="link">{row.name}</div>
                        <div>{row.mobile}</div>
                        <div>{row.email}</div>
                        <div>{row.date}</div>
                        <div className="icon">📄</div>
                        <div className="actions">
                            <span className="green">↩</span>
                            <span className="green">✎</span>
                        </div>
                    </div>
                ))}
            </div> */}
        </div>
    );
};

export default RespondentPreview;